<template>
	<inertia-head title="Join" />
	<div class="bg-trc-main">
		<div class="bg-black-25">
			<div class="content text-center">
				<div class="py-0 mb-3">
					<h1 class="fw-bold text-white mb-2">Join TRC Gold Member</h1>
					<h2 class="h4 fw-normal text-white-75 fs-sm">
						Do you want to gain access to the TRC Gold Member? Join now
					</h2>
				</div>
			</div>
		</div>
	</div>
	<div class="content">
		<div
			v-if="form.errors.subscription"
			class="alert alert-danger shadow"
			role="alert"
		>
			<h3 class="alert-heading fs-5 fw-bold mb-1">Please choose subscription</h3>
			<p class="mb-0">{{ form.errors.subscription }}</p>
		</div>
		<div v-if="$page.props.flash && $page.props.flash.title" class="alert" 
			:class="$page.props.flash.title=='Status Success' ? 'alert-success' :'alert-danger'" role="alert"
		>
			<h3 class="alert-heading fs-5 fw-bold mb-1">{{ $page.props.flash.title }}</h3>
			<p class="mb-0">{{ $page.props.flash.message }}</p>
		</div>
		<div v-if="!$page.props.flash && pending" class="border border-default p-4 bg-white">
			<h3 class="fs-5 fw-bold mb-1">Transaction Status</h3>
			<p>
				<span v-if="pending.status==null">The transaction is still <span class="text-danger fw-bold">pending</span> and the payment process is not yet complete</span>
				<!-- <span v-else>{{pending.message}}</span> -->
			</p>
			<p class="my-2 fw-bold">
				Below is the details:
			</p>
			<div>
				<p class="my-1">Registered: {{pending.created_at}}</p>
				<p class="my-1">Payment Method: {{pending.payment_method}}</p>
				<p class="my-1">Subscription: {{pending.subscription}}</p>
			</div>
		</div>
	</div>
	
	<div class="content">
		<div class="row">
			<div class="col-xl-5 col-lg-5">
				<div class="block block-rounded">
					<div class="block-header block-header-default">
						<h3 class="block-title">Choose Subscription</h3>
					</div>
					<div class="block-content block-content-full">
						<div class="row">
							<div
								class="col-12"
								v-for="product in products"
								:key="product.prod_id"
							>
								<div class="form-check form-block mb-3">
									<input
										v-model="form.subscription"
										class="form-check-input"
										type="radio"
										:value="product.prod_id"
										:id="product.prod_id"
										name="subscription"
									/>
									<label class="form-check-label" :for="product.prod_id">
										<span class="d-flex align-items-center">
											<h6 class="fs-sm mb-0">
												{{ product.membership_type }}
											</h6>
											<span
												v-if="product.add_display"
												class="badge bg-warning ms-1"
											>
												{{ product.add_display }}
											</span>
										</span>
										<small>&#8369;{{ product.amount }}</small>
									</label>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="col">
				<div class="block block-rounded">
					<div class="block-header block-header-default">
						<h3 class="block-title">Choose Payment method</h3>
					</div>
					<div class="block-content block-content-full">
						<form @submit.prevent="joinTRCGold">
							<div class="row">
								<div class="col-6">
									<div class="form-check form-block mb-4">
										<input
											v-model="form.payment_method"
											class="form-check-input"
											type="radio"
											value="CARD"
											id="card"
											name="payment_method"
										/>
										<label class="form-check-label" for="card">
											<span
												class="d-flex align-items-center"
												style="
													background-image: url(/media/logo/stripe-logo.png);
													background-size: contain;
													background-repeat: no-repeat;
													background-position: center;
													height: 80px;
												"
											>
											</span>
										</label>
									</div>
								</div>
								<div v-if="payment_available==true" class="col-6">
									<div class="form-check form-block mb-4">
										<input
											v-model="form.payment_method"
											class="form-check-input"
											type="radio"
											:value="'DRAGONPAY'"
											id="dragonpay"
											name="payment_method"
										/>
										<label class="form-check-label" for="dragonpay">
											<span
												class="d-flex align-items-center"
												style="
													background-image: url(/media/logo/dragonpay.png);
													background-size: contain;
													background-repeat: no-repeat;
													background-position: center;
													height: 80px;
												"
											>
											</span>
										</label>
									</div>
								</div>
								<div v-if="payment_available==true" class="col-6">
									<div class="form-check form-block mb-4">
										<input
											v-model="form.payment_method"
											class="form-check-input"
											type="radio"
											:value="'DRAGONPAY-GCASH'"
											id="dragonpay_gcash"
											name="payment_method"
										/>
										<label class="form-check-label" for="dragonpay_gcash">
											<span
												class="d-flex align-items-center"
												style="
													background-image: url(/media/logo/gcash.png);
													background-size: contain;
													background-repeat: no-repeat;
													background-position: center;
													height: 80px;
												"
											>
											</span>
										</label>
									</div>
								</div>
							</div>
							<div v-if="form.payment_method == 'CARD'">
								<div v-if="has_card">
									<div class="form-check form-switch mb-4">
										<input
											v-model="form.use_existing_card"
											class="form-check-input"
											type="checkbox"
											:value="true"
											id="example-switch-default1"
											name="example-switch-default1"
										/>
										<label class="form-check-label" for="example-switch-default1">
											Use existing card
										</label>
									</div>
									<div v-if="form.use_existing_card" class="mb-4">
										<p class="mb-0">
											<span class="fw-semibold">CARD:</span>
											<i>**** **** **** {{ card.last4 }}</i>
											<span class="badge bg-primary ms-2">{{ card.brand }}</span>
											<span>
												<button @click="deleteCCDetails" type="button" class="btn btn-xs btn-outline-danger ms-1" title="Delete My Credit Card Details"><i class="fa fa-trash"></i></button>
											</span>
										</p>
									</div>
								</div>
								<div v-if="!form.use_existing_card" class="form-group mb-4">
									<stripe @accept-token="acceptToken" ref="stripe" />
									<div v-if="form.errors.card" class="invalid-feedback d-block">
										<i class="fa fa-exclamation-circle"></i>
										{{ form.errors.card }}
									</div>
								</div>
							</div>
							<div class="mb-5">
								<div class="form-floating">
									<input
										type="text"
										class="form-control"
										id="coupon_code"
										v-model="form.coupon_code"
										:class="{ 'is-invalid': form.errors.coupon_code }"
										placeholder="Enter your email"
									/>
									<label class="form-label" for="coupon_code">Coupon Code</label>
									<div v-if="form.errors.coupon_code" class="invalid-feedback">
										<i class="fa fa-exclamation-circle"></i>
										{{ form.errors.coupon_code }}
									</div>
								</div>
							</div>
							<div class="mb-4 text-end space-x-1">
								<button
									class="btn btn-alt-primary"
									:disabled="
										form.processing ||
										!form.subscription ||
										(form.payment_method === 'CARD' && !form.use_existing_card && !form.token)
									"
								>
									
									<span v-if="!form.processing">Pay Now!</span>
									<span v-else>
										<div class="spinner-border spinner-border-sm text-dark" role="status" >
											<span class="sr-only mr-1">Please wait...</span>
										</div>
										<span class="mx-2">Please wait...</span>
									</span>
								</button>
							</div>
						</form>
					</div>
				</div>
			</div>
		</div>

		<modal ref="deleteCreditCardModal">
			<template #title>Delete Credit Card Details</template>
			<template #body>
				<p class="text-danger fw-bold">Are you sure you want to delete your card details?</p>
				<p class="text-danger fw-bold">Your membership will not auto-renew and you might lose some of your benefits.</p>
			</template>
			<template #footer>
				<button @click="confirmDeleteCC" type="button" class="btn btn-alt-danger" :disabled="formCC.processing">
					<div
						v-if="formCC.processing"
						class="spinner-border spinner-border-sm text-dark me-1"
						role="status"
					>
						<span class="sr-only">Loading...</span>
					</div>
					<i v-else class="fa fa-trash me-1"></i>
					<span>YES</span>
				</button>
				<button @click="deleteCreditCardModal.toggleModal" type="button" class="btn btn-alt-secondary">
					<i class="fa fa-times me-1"></i>NO
				</button>
			</template>
		</modal>

	</div>
</template>

<script>

window.dataLayer = window.dataLayer || [];
function gtag(){dataLayer.push(arguments);}
gtag('js', new Date());

gtag('config', window.gtag_id);

import { onMounted, watch, ref } from 'vue'
import AuthLayout from '../../Layouts/AuthLayout'
import { useForm } from '@inertiajs/inertia-vue3'
import Stripe from '../../Shared/Components/Stripe'

export default {
	layout: AuthLayout,
	props: {
		test: String,
		flash: Object,
		products: Object,
		has_card: Boolean,
		card: Object,
		rebates: Object
	},
	components: {
		Stripe,
	},
	setup(props) {

		const payment_available = ref(true);

		const deleteCreditCardModal = ref(null);

		onMounted(() => {
			const pageContainer = document.getElementById('page-container')
			if (pageContainer.classList.contains('sidebar-o-xs'))
				pageContainer.classList.remove('sidebar-o-xs')
		})

		const form = useForm({
			action 				: 'upgrade',
			payment_method 		: 'CARD',
			pmethod 			: null,
			pchannel 			: null,
			subscription 		: null,
			token 				: null,
			rebates 			: props.rebates,
			use_existing_card 	: props.has_card?true:false,
			test 				: props.test,
			coupon_code 		: null,
		})

		const acceptToken = (token) => {
			form.token = token
		}

		const deleteCCDetails = ()=>{
			deleteCreditCardModal.value.toggleModal();
		}

		const confirmDeleteCC = ()=>{
			formCC.post(route('member.post.cc-details'),{
				preserveScroll: true,
				only:['flash,member,subscriptions'],
				onSuccess: ()=>{
					deleteCreditCardModal.value.toggleModal();
					form.use_existing_card = false;
				}
			})
		}

		const joinTRCGold = () => {
			form.post(route('member.post.upgrade'), {
				preserveState: true,
				preserveScroll: true,
			})
		}

		watch(
			() => form.payment_method,
			(payment_method) => {
				
				if(payment_method=='CARD' && props.has_card)
				{
					form.use_existing_card = true;
				}else{
					form.use_existing_card = false;
				}

				if(payment_method!='CARD')
				{
					form.token = null;
				}
			}
		)

		watch(
			() => form.use_existing_card,
			(use_existing_card) => {
				
				if(use_existing_card==true)
				{
					form.token = null;
				}
			}
		)

		watch(
			() => form.payment_method,
			(payment_method) => {
				
				form.pmethod 	= null;
				form.pchannel 	= null;	

				if(payment_method=='CARD' && props.has_card)
				{
					form.use_existing_card = true;
				}else{
					form.use_existing_card = false;
				}

				if(payment_method!='CARD')
				{
					form.token = null;

					if(payment_method=='DRAGONPAY-GCASH')
					{
						form.pmethod 	= 'GCASH';
						form.pchannel 	= 'GCSH';
					}

				}
			}
		)

		watch(()=>form.subscription,(value)=>{
			let val = value.split('+');
			if(value && val[0].includes("1M"))
			{
				form.payment_method = 'CARD';
				payment_available.value = false;

				form.pmethod 	= null;
				form.pchannel 	= null;	

			}else
			{
				payment_available.value = true;
			}
		})

		return {
			deleteCreditCardModal,
			form,
			joinTRCGold,
			acceptToken,
			deleteCCDetails,
			confirmDeleteCC,
			payment_available,
		}
	},
}
</script>
